import { NodeSelection } from '@tiptap/pm/state'
import { useEditorState, type Editor } from '@tiptap/react'

export interface SelectedBlock {
  pos: number
  type: string
  attrs: Record<string, unknown>
}

const CONTAINERS = ['condition', 'repeat', 'note']

function findSelected(editor: Editor): SelectedBlock | undefined {
  const { selection } = editor.state
  if (selection instanceof NodeSelection) {
    return { pos: selection.from, type: selection.node.type.name, attrs: selection.node.attrs }
  }
  const { $from } = selection
  for (let depth = $from.depth; depth > 0; depth--) {
    const node = $from.node(depth)
    if (CONTAINERS.includes(node.type.name)) {
      return { pos: $from.before(depth), type: node.type.name, attrs: node.attrs }
    }
  }
  return undefined
}

/** Ayar paneli için seçili blok: seçili atom (widget, değer, sayfa sonu) ya da imlecin içinde olduğu condition/repeat/note. */
export function useSelectedBlock(editor: Editor): SelectedBlock | undefined {
  return useEditorState({
    editor,
    selector: ({ editor: current }) => findSelected(current),
  })
}
